import { render, staticRenderFns } from "./SendAlertModal.vue?vue&type=template&id=0829f714&scoped=true"
import script from "./SendAlertModal.vue?vue&type=script&lang=ts"
export * from "./SendAlertModal.vue?vue&type=script&lang=ts"
import style0 from "./SendAlertModal.vue?vue&type=style&index=0&id=0829f714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0829f714",
  null
  
)

export default component.exports